
import { mapState, mapGetters, mapMutations } from 'vuex';
import * as types from '~/types';
export default {
  props: ['type', 'likeStatus', 'collectStatus'],
  data() {
    return {
      qrSource: null,
      isShow: true,
    };
  },

  computed: {
    ...mapGetters('user', ['isFollow', 'isLogin']),
    ...mapState(['user']),
  },
  watch: {
    scrollTopNum() {},
  },
  mounted() {
    window.addEventListener('scroll', () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const doc = document.querySelector('#glh-footer');
      const footerTop = doc.offsetTop;
      const footerHeight = doc.offsetHeight;
      if (footerTop - scrollTop < footerHeight) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    });
    if (document.documentElement.scrollTop) {
      document.documentElement.scrollTop += 10;
    } else if (document.body.scrollTop) {
      document.body.scrollTop += 10;
    }
  },
  methods: {
    ...mapMutations('user', [types.SHOW_LOGIN_FORM]),
    goComment() {
      const holdHeight = 150;
      const doc = document.querySelector('#article-comment');
      const scrollTopNum = doc.offsetTop;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const cutNum = Math.abs(
        parseInt(scrollTopNum) - parseInt(scrollTop) - holdHeight
      );
      const isDown =
        parseInt(scrollTopNum) - parseInt(scrollTop) - holdHeight > 0
          ? true
          : false;
      const y = parseInt(cutNum / 50);
      const runInterval = setInterval(() => {
        if (
          Math.abs(
            parseInt(scrollTopNum) -
              parseInt(
                document.documentElement.scrollTop || document.body.scrollTop
              ) -
              holdHeight
          ) <
          2 * y
        ) {
          clearInterval(runInterval);
          if (
            typeof document.documentElement.scrollTop !== 'undefined' &&
            document.documentElement.scrollTop !== 0
          ) {
            document.documentElement.scrollTop = isDown
              ? document.documentElement.scrollTop +
                Math.abs(
                  parseInt(scrollTopNum) -
                    parseInt(
                      document.documentElement.scrollTop ||
                        document.body.scrollTop
                    ) -
                    holdHeight
                )
              : document.documentElement.scrollTop -
                Math.abs(
                  parseInt(scrollTopNum) -
                    parseInt(
                      document.documentElement.scrollTop ||
                        document.body.scrollTop
                    ) -
                    holdHeight
                );
          } else if (
            typeof document.body.scrollTop !== 'undefined' &&
            document.documentElement.scrollTop !== 0
          ) {
            document.body.scrollTop = isDown
              ? document.body.scrollTop +
                Math.abs(
                  parseInt(scrollTopNum) -
                    parseInt(
                      document.documentElement.scrollTop ||
                        document.body.scrollTop
                    ) -
                    holdHeight
                )
              : document.body.scrollTop -
                Math.abs(
                  parseInt(scrollTopNum) -
                    parseInt(
                      document.documentElement.scrollTop ||
                        document.body.scrollTop
                    ) -
                    holdHeight
                );
          }
        } else {
          if (typeof document.documentElement.scrollTop !== 'undefined') {
            document.documentElement.scrollTop = isDown
              ? document.documentElement.scrollTop + y
              : document.documentElement.scrollTop - y;
          } else if (typeof document.body.scrollTop !== 'undefined') {
            document.body.scrollTop = isDown
              ? document.body.scrollTop + y
              : document.body.scrollTop - y;
          }
        }
      }, 5);
      setTimeout(() => {
        if (runInterval) {
          clearInterval(runInterval);
        }
      }, 1300);
    },
    collect() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      this.$emit('collect', true);
    },
    like() {
      if (!this.isLogin) {
        this[types.SHOW_LOGIN_FORM]();
        return;
      }
      this.$emit('like', true);
    },
  },
};
